import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";

const UNIT = { sqft: "per sq ft", piece: "each", joint: "per joint" };

// Admin: builder options priced from the supplier list, and prices for the ones the list does not price.
export function BuilderPricesSection() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/builder/options").then((r) => setRows(r.data.prices || [])).catch((e) => toast.error(errorMessage(e))); }, []);
  const save = async (key, raw) => {
    const v = String(raw).trim() === "" ? null : Number(raw);
    if (v !== null && !(v >= 0)) return toast.error("Enter a price of 0 or more");
    try { const { data } = await api.put("/builder/prices", { prices: { [key]: v } }); setRows(data); toast.success("Price saved"); } catch (e) { toast.error(errorMessage(e)); }
  };
  if (!rows) return null;
  return (
    <div className="space-y-3" data-testid="builder-prices-section">
      <p className="text-[15px] text-[#6D6D72]">Designer options. Prices come from your supplier list. Where the list has none, the option shows "No supplier price" and adds $0 until you enter a price here.</p>
      <div className="overflow-hidden rounded-[14px] bg-white">
        {rows.map((o) => (
          <div key={o.key} data-testid={`builder-price-row-${o.key}`} className="flex flex-wrap items-center gap-3 border-b border-black/[0.08] px-4 py-3 last:border-0">
            <div className="min-w-[220px] flex-1">
              <p className="text-[15px] font-medium text-black">{o.label}</p>
              <p className="text-[13px] text-[#6D6D72]">{UNIT[o.unit]}</p>
            </div>
            {o.supplier_rate != null ? (
              <p data-testid={`builder-price-supplier-${o.key}`} className="text-[14px] text-[#248A3D]">Supplier list: ${o.supplier_rate.toFixed(o.unit === "sqft" ? 4 : 2)} · {o.supplier_line}</p>
            ) : (
              <>
                {o.admin_rate == null && <span data-testid={`builder-price-missing-${o.key}`} className="rounded-full bg-[#FF9500]/15 px-2 py-0.5 text-[13px] font-semibold text-[#8A4B00]">No supplier price</span>}
                <input key={`${o.key}-${o.admin_rate}`} data-testid={`builder-price-input-${o.key}`} inputMode="decimal" placeholder="$0.00" defaultValue={o.admin_rate ?? ""}
                  onBlur={(e) => String(e.target.value) !== String(o.admin_rate ?? "") && save(o.key, e.target.value)}
                  className="h-10 w-28 rounded-[10px] border border-black/10 px-3 text-right text-[15px] outline-none focus:border-[#007AFF]" />
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
